import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserAddModelComponent } from '../user-add-model/user-add-model.component';
import { UserQrGeneratorModelComponent } from '../user-qr-generator-model/user-qr-generator-model.component';
import { Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { Location } from '@angular/common'
@Component({
  selector: 'app-about-us-view',
  templateUrl: './about-us-view.component.html',
  styleUrls: ['./about-us-view.component.sass']
})
export class AboutUsViewComponent {
  constructor( private location: Location,private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService,private _function:FunctionsService) { }
  ngOnInit(): void {

  }
  back() {
    this.location.back();
  }
}
